module.exports = __webpack_public_path__ + "img/megaphone.0e45c7c1.svg";